import { PersonExplorerPart } from './person/person-explorer.part';

/**
 * Array that contains all of the explorer components.
 */
export const EXPLORERS = [
	PersonExplorerPart,
] as const;